<template>
  <v-dialog v-model="dialogModel" width="900">
    <v-card>
      <v-card-title>
        <div class="d-flex align-center">
          AI Report
          <v-btn
            color="primary"
            :loading="isLoading"
            class="mx-2"
            @click="generateReport"
          >
            {{ $t("ai-report-generate") }}
          </v-btn>
          <v-btn icon @click="fetchReport">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text>
        <v-row class="mt-2">
          <v-col v-if="isLoading" cols="12">
            <v-alert
              border="left"
              text
              type="info"
              color="techBlue"
              class="mt-2"
            >
              {{ $t("ai-report-generating") }}
            </v-alert>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="reports"
              hide-default-footer
              :items-per-page="-1"
              :loading="isRefreshing"
            >
              <template #[`item.status`]="{ item }">
                <AiReportStatus :status="item.status" />
              </template>
              <template #[`item.actions`]="{ item }">
                <v-btn
                  icon
                  color="success"
                  :disabled="item.status != 3"
                  @click="downloadReport(item.id)"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialogModel = false">{{ $t("close") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { AiReportService } from "@/services";
import { DownloadFile } from "@/utilities/fileManager.js";
import AiReportStatus from "@/components/ai/AiReportStatus.vue";

export default {
  name: "AiReportDialog",
  components: { AiReportStatus },
  props: {
    value: Boolean,
  },
  data() {
    return {
      isLoading: false,
      isRefreshing: false,
      nestedDialog: false,
      reports: [],
      intervalId: null,
      headers: [
        { text: this.$t("title"), value: "title" },
        { text: this.$t("status"), value: "status" },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    dialogModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    ...mapGetters({
      businessPlan: "businessPlan/getBusinessPlan",
    }),
  },
  watch: {
    dialogModel(val) {
      if (val) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
    },
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
  methods: {
    startAutoRefresh() {
      this.fetchReport();
      this.intervalId = setInterval(this.fetchReport, 60000);
    },
    stopAutoRefresh() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    async fetchReport() {
      this.isRefreshing = true;
      await new Promise((r) => setTimeout(r, 250));

      try {
        const apiReports = await AiReportService.get(this.businessPlan.id);
        if (Array.isArray(apiReports)) {
          this.reports = apiReports.map((r) => ({
            id: r.id,
            title: r.title,
            status: r.status,
          }));
        } else {
          this.reports = [];
        }
      } catch (error) {
        console.error("Errore nel fetch report:", error);
        this.reports = [];
      } finally {
        this.isRefreshing = false;
      }
    },
    async generateReport() {
      this.isLoading = true;
      try {
        await AiReportService.generate(this.businessPlan.id);
        await this.fetchReport();
      } catch (error) {
        console.error("Errore durante la generazione:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async downloadReport(reportId) {
      try {
        const { url, filename } = await AiReportService.download(reportId);
        DownloadFile.downloadFileFromUrl(url, filename);
      } catch (error) {
        console.error("Errore nel download:", error);
      }
    },
    //  async deleteReport(id) {
    //   this.nestedDialog = false;
    //   await AiReportService.remove(id);
    // },
  },
};
</script>
